export default __webpack_public_path__ + "static/media/vr.0e4ba776.png";